import { ExecuteEndpoint } from '../../components/common/BaseApiService';
import { MainDocContentTypeResponse } from '../../Model/responseDtos/MainDocContentTypeResponse';

export class ContentTypesService {
  public async getCtsWithCreatePermission(indexId: number): Promise<string[]> {
    const searchParams = new URLSearchParams();
    searchParams.append('indexId', indexId.toString());
    const queryParams = `?${searchParams.toString()}`;

    return ExecuteEndpoint(`content-types/with-create-permission${queryParams}`, 'GET');
  }

  public async getContentType(ctName: string, locale?: string): Promise<MainDocContentTypeResponse> {
    if (locale) {
      const searchParams = new URLSearchParams();
      searchParams.append('locale', locale.toString());
      const queryParams = `?${searchParams.toString()}`;
      return ExecuteEndpoint(`content-types/${ctName}${queryParams}`, 'GET');
    }

    return ExecuteEndpoint(`content-types/${ctName}`, 'GET');
  }
}
